import Vue from 'vue'
import vuex from 'vuex'
import self from './modules/self'
import session from './modules/session'

Vue.use(vuex)

const store = new vuex.Store({
  modules: {
    self,
    session
  }
})

export default store
